import '../instagram_content_view.js.coffee'
Namespace 'Monitoring.Views.SocialContents.InstagramBusinessListening'

class Monitoring.Views.SocialContents.InstagramBusinessListening.InstagramBusinessListeningContentView extends
      Monitoring.Views.SocialContents.InstagramContentView

  getHeaderView: (options) ->
    el = options.el
    model = options.model
    new Monitoring.Views.SocialContents.InstagramBusinessListening.InstagramBusinessListeningHeaderView(el, model)
